import { render, staticRenderFns } from "./ViewInternalOrder.vue?vue&type=template&id=1db6735e"
import script from "./ViewInternalOrder.vue?vue&type=script&lang=js"
export * from "./ViewInternalOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports